const trimDecimalZeros = value => {
	if (value) {
		return value.replace(/\.?0+$/, '');
	}
	return value;
};

export default trimDecimalZeros;
